module.exports = __webpack_public_path__ + "static/media/signing_complete.a63454ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/signing_complete.svg
// module id = 1364
// module chunks = 0